import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('admin');
export const apiRoutes = {
  adminSourceTab: `${URI_PREFIX}/headless/sources`,
  adminSourceLogsTab: `${URI_PREFIX}/headless/sources/logs`,
  adminSourceAutoComplete: `${URI_PREFIX}/headless/sources`,
  adminSourceActionAutoComplete: `${URI_PREFIX}/headless/actions`,
  adminSourceResponseAutoComplete: `${URI_PREFIX}/headless/sources/logs/response`,
  adminRequestBodyAutoComplete: `${URI_PREFIX}/headless/sources/logs/request-body`,
  adminMicroserviceOptions: `${URI_PREFIX}/headless/microservices`,
  adminSourceTypeOptions: `${URI_PREFIX}/headless/sources/types`,
  adminCheckAction: `${URI_PREFIX}/headless/sources/check`,
  //ElasticsearchIndexes
  adminElasticsearchIndexes: `${URI_PREFIX}/elasticsearch/indexes/`,
  adminModulesOptions: `${URI_PREFIX}/elasticsearch/indexes/modules`,
  adminLogsModulesOptions: `${URI_PREFIX}/elasticsearch/indexes/logs/modules`,
  adminNameAutoComplete: `${URI_PREFIX}/elasticsearch/indexes`,
  adminStatusOptions: `${URI_PREFIX}/statuses/active-deactivated`,
  adminElasticsearchLogsIndexes: `${URI_PREFIX}/elasticsearch/indexes/logs`,
  adminNameLogsAutoComplete: `${URI_PREFIX}/elasticsearch/indexes/logs`,
  adminOperationsOptions: `${URI_PREFIX}/elasticsearch/indexes/operations`,
  adminStatusLogsOptions: `${URI_PREFIX}/statuses/success-failure`,
  adminSyncAction: `${URI_PREFIX}/elasticsearch/indexes/full/sync`,
  adminPartialSyncAction: `${URI_PREFIX}/elasticsearch/indexes/partial/sync`,
  adminMappingAction: `${URI_PREFIX}/elasticsearch/indexes/mapping`,
  adminSettingsAction: `${URI_PREFIX}/elasticsearch/indexes/settings`,
  adminLogs: `${URI_PREFIX}/elasticsearch/indexes/admin/logs`,
  adminActions: `${URI_PREFIX}/elasticsearch/indexes/admin/logs/actions`,
  // news
  adminNewsLogs: `${URI_PREFIX}/news/scraper/logs/`,
  adminNewsLogsUrlsAutoComplete: `${URI_PREFIX}/news/scraper/logs/url`,
  adminNewsLogsSourceAutoComplete: `${URI_PREFIX}/news/scraper/logs/source`,
  adminNewsLogsEditionAutoComplete: `${URI_PREFIX}/news/scraper/logs/source/editions`,
  adminNewsLogsItemTypes: `${URI_PREFIX}/news/scraper/logs/items/types`,
};
